module.exports = __webpack_public_path__ + "static/media/plus.e69a7e97.svg";